'use client';

import * as React from 'react';
import { withRequiredPermission } from '@/components/auth/with-required-permission';
import { PERMISSIONS } from '@/hooks/use-perm';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { TableCard } from '@/components/ui/table-card';
import { useOffersList } from '@/lib/api/offers';
import { OffersTable } from './components/OffersTable';
import { useStoreNavigate } from '@/hooks/use-app-navigate';

const OffersPage = () => {
  const { storeRoutes, navigate, id } = useStoreNavigate();
  const { t } = useTranslation(['stores', 'common']);

  const {
    data: offersResponse,
    isLoading: loading,
    error,
    refetch,
  } = useOffersList({ storeId: id });

  const offers = offersResponse?.offers || [];
  const total = offers.length;

  return (
    <div className="flex flex-col space-y-4 sm:space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div>
          <h1 className="text-xl font-semibold sm:text-2xl">{t('stores:offers')}</h1>
          <p className="text-muted-foreground text-sm">{t('stores:manageOffersDescription')}</p>
        </div>
        <div className="flex items-center gap-2">
          <Button className="w-full sm:w-auto" onClick={() => navigate(storeRoutes.OFFER_CREATE())}>
            <Plus className="size-4" />
            {t('stores:addOffer')}
          </Button>
        </div>
      </div>
      <TableCard>
        <OffersTable
          offers={offers}
          total={total}
          loading={loading}
          onTableStateChange={() => {}}
          onRefetch={refetch}
        />

        {error && (
          <div className="mt-4 rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700">
            {error instanceof Error ? error.message : t('stores:loadOffersError')}
          </div>
        )}
      </TableCard>
    </div>
  );
};

const OffersPageGuarded = withRequiredPermission(OffersPage, PERMISSIONS.STORES_VIEW);
export default OffersPageGuarded;
export { OffersPageGuarded as OffersPage };
